import type {DisplayUsdQuote, SourceAssetPrice} from '../../../../packages/sdk/src';

// Display estimate only; executable acquisition still uses the protected route quote.
export function receiptReference(amount:string, bnb:DisplayUsdQuote|null|undefined, source:SourceAssetPrice|undefined, now=Date.now()) {
  if(!/^\d+(\.\d+)?$/.test(amount)||!bnb||!source||bnb.quoteSymbol!=='BNB'||![now,bnb.asOf,bnb.validUntil,source.fetchedAt,source.validUntil].every(Number.isFinite)||bnb.validUntil<=now||source.validUntil<=now||bnb.asOf>now+30000||source.fetchedAt>now+30000)return null;
  const input=Number(amount),nativeUsd=Number(bnb.usd),sourceUsd=Number(source.usd);
  if(![input,nativeUsd,sourceUsd].every(n=>Number.isFinite(n)&&n>0))return null;
  const units=input*nativeUsd/sourceUsd;
  return Number.isFinite(units)?{units,nativeUsd,sourceUsd}:null;
}
